/**
 * This file is automatically generated using generator/actions/generate-action.ts.
 * Do NOT modify this file by hand.
 */

import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { CancelUserTemporaryPinCodePathParameters } from 'api/actions/cancel-user-temporary-pin-code/cancel-user-temporary-pin-code-path-parameters';
import { CancelUserTemporaryPinCodeResponse } from 'api/actions/cancel-user-temporary-pin-code/cancel-user-temporary-pin-code-response';

type CancelUserTemporaryPinCodeQueryParameters = Record<string, any>;

/**
 * The path of the CancelUserTemporaryPinCode action.
 */
export const cancelUserTemporaryPinCodeActionPath = new SweetPath<keyof CancelUserTemporaryPinCodePathParameters>(
  '/user/pin/temporary/{temporaryPinCodeId}/cancel',
  { path: '{param}' }
);

/**
 * Creates a contextualized CancelUserTemporaryPinCode actions.
 */
export default function createCancelUserTemporaryPinCodeAction(axios: AxiosInstance) {
  return function cancelUserTemporaryPinCodeAction({
    headers = {},
    parameters,
    query = {},
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    parameters: CancelUserTemporaryPinCodePathParameters;
    query?: CancelUserTemporaryPinCodeQueryParameters;
  }) {
    const path = cancelUserTemporaryPinCodeActionPath.insert(parameters);

    return axios.post<CancelUserTemporaryPinCodeResponse, CancelUserTemporaryPinCodeResponse>(path, {
      params: query,
      headers,
    });
  };
}
